"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BulletSettings;
exports.initialValues = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _style = _interopRequireDefault(require("../common/style.css"));
var _FieldGroup = _interopRequireDefault(require("../common/FieldGroup"));
var _ThemeFields = _interopRequireDefault(require("../common/ThemeFields"));
var _RangeFieldArray = _interopRequireDefault(require("../common/RangeFieldArray"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialValues = {
  layout: 'horizontal',
  minValue: 0,
  maxValue: 'auto',
  rangeColors: ['#d9534f', '#f0ad4e', '#5cb85c'],
  measureColors: ['#337ab7'],
  customColors: '#b3e2cd',
  axisLeft: {
    legendPosition: 'middle',
    legendOffset: -50
  },
  axisBottom: {
    legendPosition: 'middle',
    legendOffset: 50
  },
  margin: {
    left: 80,
    right: 150,
    top: 50,
    bottom: 80
  }
};
exports.initialValues = initialValues;
function BulletSettings(_ref) {
  var field = _ref.field,
    form = _ref.form,
    children = _ref.children;
  (0, _react.useEffect)(function () {
    form.setFieldValue("".concat(field.name), _objectSpread(_objectSpread({}, initialValues), field.value));
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].settings
  }, /*#__PURE__*/_react["default"].createElement(BulletSettings.Chart, {
    field: field,
    form: form
  }), /*#__PURE__*/_react["default"].createElement(BulletSettings.Ranges, {
    field: field,
    form: form
  }), /*#__PURE__*/_react["default"].createElement(BulletSettings.Theme, {
    field: field,
    form: form
  }), children);
}
BulletSettings.Chart = function (_ref2) {
  var field = _ref2.field,
    form = _ref2.form,
    children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Chart"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "".concat(field.name, ".measureColors[0]")
  }, function (_ref3) {
    var thisField = _ref3.field;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '1em'
      }
    }, field.value.measureColors && field.value.measureColors.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", null, "Measure Color"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "btn-group"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      style: {
        backgroundColor: field.value.measureColors[0]
      },
      type: "button",
      className: "btn btn-default dropdown-toggle",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "caret"
    })), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "dropdown-menu dropdown-menu-right",
      style: {
        width: '4em'
      }
    }, /*#__PURE__*/_react["default"].createElement("li", {
      onClick: function onClick() {
        return form.setFieldValue("".concat(field.name, ".measureColors[0]"), '#337ab7');
      },
      style: {
        padding: '0.5em 1em'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "form-control",
      style: {
        backgroundColor: '#337ab7'
      }
    })), /*#__PURE__*/_react["default"].createElement("li", {
      onClick: function onClick() {
        return form.setFieldValue("".concat(field.name, ".measureColors[0]"), '#d9534f');
      },
      style: {
        padding: '0.5em 1em'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "form-control",
      style: {
        backgroundColor: '#d9534f'
      }
    })), /*#__PURE__*/_react["default"].createElement("li", {
      onClick: function onClick() {
        return form.setFieldValue("".concat(field.name, ".measureColors[0]"), '#f0ad4e');
      },
      style: {
        padding: '0.5em 1em'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "form-control",
      style: {
        backgroundColor: '#f0ad4e'
      }
    })), /*#__PURE__*/_react["default"].createElement("li", {
      onClick: function onClick() {
        return form.setFieldValue("".concat(field.name, ".measureColors[0]"), '#5cb85c');
      },
      style: {
        padding: '0.5em 1em'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "form-control",
      style: {
        backgroundColor: '#5cb85c'
      }
    })), /*#__PURE__*/_react["default"].createElement("li", {
      style: {
        padding: '0.5em 1em'
      }
    }, /*#__PURE__*/_react["default"].createElement("input", _extends({
      type: "color"
    }, thisField, {
      className: "form-control"
    })))))));
  }), children);
};
BulletSettings.Ranges = function (_ref4) {
  var field = _ref4.field,
    form = _ref4.form,
    children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Ranges"
  }, /*#__PURE__*/_react["default"].createElement(_RangeFieldArray["default"], {
    field: field,
    form: form
  }), children);
};
BulletSettings.Theme = function (_ref5) {
  var field = _ref5.field,
    form = _ref5.form,
    children = _ref5.children;
  return /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Theme"
  }, /*#__PURE__*/_react["default"].createElement(_ThemeFields["default"], {
    field: field,
    form: form,
    hideColorScheme: true
  }), children);
};